import React, { useEffect, useState } from "react";
import {
  AllTabType,
  IqueryParams,
  IResultList,
} from "src/types/GlobalInterfaces";
import DrawerTitle from "../Drawer/DrawerTitle";
import OrdersCard from "../Cards/OrdersCard";
import MyResultsCard from "../Cards/MyResultsCard";
import PaginationWrapper from "../WebsiteComponents/PaginationWrapper";
import httpRequest from "src/helpers/httpRequest";
import { IPaginated } from "src/types/paginated";
import { useSelector } from "react-redux";
import { RootState } from "src/Store/store";
import { toast } from "react-toastify";
import qs from "qs";
import NoItemUI from "../NoItemUI";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import InfinteScrollWrapper from "../GlobalComponents/Widget/InfinteScrollWrapper";
import { updateRedDots } from "src/Store/redDots";
import { useDispatch } from "react-redux";
import { AppDispatch } from "src/Store/store";

interface IProps {
  onBack?: () => void;
  setActiveTab?: (tab: AllTabType) => void;
  onClose?: () => void;
}

interface IMyResultsResponse {
  documents: IResultList[];
  paginated: IPaginated;
}

const MyResultsScreen: React.FC<IProps> = ({
  onBack,
  setActiveTab,
  onClose,
}) => {
  const { userDetails } = useSelector((store: RootState) => store.appReducer);
  const uId = userDetails?._id || ""; // user id
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [isLoader, setIsLoader] = useState<boolean>(false); // Loader state
  const [allResults, setAllResults] = useState<IResultList[]>([]); // List of results
  const [paginated, setPaginated] = useState<IPaginated>({
    // Pagination state
    currentPage: 1,
    totalPages: 1,
  });
  const [queryParams, setQueryParams] = useState<IqueryParams>({
    // Query parameters for API call
    page: 1,
    limit: 10,
    search: "",
  });

  // Handles page change in pagination
  const handlePageChange = (e: number) => {
    setQueryParams((prev) => ({
      ...prev,
      page: e,
    }));
  };

  // API_CALL: Fetches my results from the server
  const fetchMyResults = async (_id: string , q : IqueryParams) => {
    setIsLoader(true);
    const { res, err } = await httpRequest<IMyResultsResponse>({
      path: `/test/${_id}?${qs.stringify(q)}`,
    });
    if (res) {
      const { documents = [], paginated } = res;

      setAllResults(prev => [...prev , ...documents]);
      setPaginated(paginated);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  const handleChangeQuery = (data : Partial<IqueryParams> , isReset = false) => {
    let q = {...queryParams , ...data}
    setQueryParams(q)
    if(isReset) {
      setAllResults([])
      q.page = 1
    }
    fetchMyResults(uId , q)
  }

  useEffect(() => {
    if (uId) {
      handleChangeQuery({} , true)
    }
  }, [uId]);

  return (
    <>
      <DrawerTitle title="My Results" backBtn onBack={onBack} />
      <div className="w-full h-full flex flex-col side-bar-padding">
        <InfinteScrollWrapper
          isLoading={isLoader}
          length={allResults.length}
          currentPage={queryParams.page}
          totalPages={paginated.totalPages}
          onLoadMore={(page: number) => {
            handleChangeQuery({page})
          }}
          // isLoadButton={true}
          noDataOptions={{
            text2: "No Results Found",
          }}
        >
          {allResults.map((item, index) => {
            return (
              <MyResultsCard
                key={index}
                orderId={`#${(index + 1).toString().padStart(2, "0")}`}
                message={item?.testName}
                date={moment(item?.date).format("DD MMM YYYY")}
                result={[
                  item?.green as number,
                  item?.orange as number,
                  item?.red as number,
                ]}
                onViewDetails={() => {
                  if(item?.customerTestNotified) {
                    dispatch(updateRedDots({ resultNotified: 0 }));
                  }
                  navigate(`/test-result/${item?._id}/view`);
                  onClose?.();
                }}
                read={item?.customerTestNotified}
              />
            );
          })}
        </InfinteScrollWrapper>
      </div>
    </>
  );
};

export default MyResultsScreen;
